module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"averageProgress":"Average progress","trainingPaths":"paths"},"fr":{"averageProgress":"Moyenne avancement","trainingPaths":"parcours"}}')
  delete Component.options._Ctor
}
